import styled, { createGlobalStyle } from 'styled-components';
export const OzoneFonts = createGlobalStyle`
  $font-prefix: '' !default;

  :root {
    --ozn-font-sans: 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;
    --ozn-font-mono: 'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace;
  }
`;
export const Sans = styled.span`
  color: var(--gray-100);
  font-family: var(--ozn-font-sans);
`;
export const Mono = styled.span`
  color: var(--gray-100);
  font-family: var(--ozn-font-mono);
`;
export const TextWrapper = styled.div`
  padding: ${({ theme })=>{
    var _theme_spacing;
    return (_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.normal;
}};
  padding-right: 15% !important;
`;
